import { Action } from '@ngrx/store';

export const SET_SHOP = '[Checkout] Set shop';
export const RESET_SHOP = '[Checkout] Reset shop';

export class SetShop implements Action {
  readonly type = SET_SHOP;

  constructor(public payload: string) {}
}

export class ResetShop implements Action {
  readonly type = RESET_SHOP;
}

export type ShopsActions = SetShop | ResetShop;
